<template>
	<div class="search-order">
		<div class="el-search vue-top-padding radius">
			<el-row :gutter="20">
				<el-col :span="2">
					<div class="el-left">
						<el-button
							size="small"
							icon="el-icon-printer"
							@click="exportOrder"
							>{{ $t("common.export") }}</el-button
						>
					</div>
				</el-col>
				<el-col :span="22">
					<div class="el-right">
						<el-form
							ref="order"
							:model="search"
							:inline="true"
							label-width="10px"
							size="small"
							class="demo-form-inline el-input-height"
						>
							<el-form-item prop="dateTime">
								<el-date-picker
									style="max-width: 320px;"
									v-model="dateTime"
									type="datetimerange"
									:picker-options="pickerOptions"
									range-separator="-"
									:start-placeholder="$t('searchOrder.start')"
									:end-placeholder="$t('searchOrder.end')"
								>
								</el-date-picker>
							</el-form-item>
							<el-form-item prop="orderNumber">
								<el-input
									v-model="search.orderNumber"
									:placeholder="$t('searchOrder.orderNumber')"
								></el-input>
							</el-form-item>
							<!--<el-form-item prop="trxNo">
                                <el-input v-model="search.trxNo" placeholder="流水号"></el-input>
                            </el-form-item>-->
							<el-form-item prop="userName">
								<el-input
									v-model="search.userName"
									:placeholder="$t('searchOrder.userName')"
								></el-input>
							</el-form-item>
							<el-form-item prop="equipmentNo">
								<el-input
									v-model="search.equipmentNo"
									:placeholder="$t('searchOrder.equipmentNo')"
								></el-input>
							</el-form-item>
							<el-form-item prop="equipmentName">
								<el-input
									v-model="search.equipmentName"
									:placeholder="$t('searchOrder.equipmentName')"
								></el-input>
							</el-form-item>
							<el-form-item prop="goodsName">
								<el-input
									v-model="search.goodsName"
									:placeholder="$t('order.SearchOrder.763343-0')"
								></el-input>
							</el-form-item>
							<el-form-item prop="payState">
								<el-select
									v-model="search.payState"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									clearable
									:placeholder="$t('searchOrder.payState')"
								>
									<el-option
										v-for="item in payStateList"
										:key="item.id"
										:label="item.label"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item prop="payType">
								<el-select
									v-model="search.payType"
									:no-data-text="$t('common.noData')"
									:no-match-text="$t('common.noData')"
									clearable
									:placeholder="$t('order.payType')"
								>
									<el-option
										v-for="item in payTypeList"
										:key="item.id"
										:label="item.label"
										:value="item.value"
									>
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-button
									type="primary"
									@click="onSubmit"
									icon="el-icon-search"
									>{{ $t("common.search") }}</el-button
								>
								<el-button
									@click="resetSearch('order')"
									icon="el-icon-refresh"
									>{{ $t("common.reset") }}</el-button
								>
							</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
export default {
	name: "SearchOrder",
	props: {
		search: Object,
		dateTime: Array,
		payStateList: Array,
		payTypeList: Array,
	},
	data() {
		return {
			pickerOptions: {
				shortcuts: [
					{
						text: this.$t("TimeControl.week"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.month"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit("pick", [start, end]);
						},
					},
					{
						text: this.$t("TimeControl.year"),
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
							picker.$emit("pick", [start, end]);
						},
					},
				],
			},
		};
	},
	methods: {
		onSubmit() {
			if (this.dateTime && this.dateTime.length > 0) {
				this.search.startTime = this.$timeUtil.formatTime(this.dateTime[0]);
				this.search.endTime = this.$timeUtil.formatTime(this.dateTime[1]);
			} else {
				this.search.startTime = "";
				this.search.endTime = "";
			}
			console.log(this.dateTime);
			this.$emit("onSubmit", this.search);
		},
		resetSearch(formName) {
			this.$refs[formName].resetFields(); // 这个只是清除了表单数据，对象并没有重新赋值，所以调用下面的方法赋空值
			this.$toolUtil.clearForm(this.search);
			this.$emit("resetSearch", this.search);
		},
		exportOrder() {
			this.$confirm(this.$t("searchOrder.export"), this.$t("common.tip"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$api.download(this.$url.Order.export, this.search);
				})
				.catch(err => {
					if (err.msg) {
						this.$message.error(err.msg);
					}
				});
		},
	},
};
</script>

<style scoped></style>
